<!-- Sidebar -->
<div class="sidebar" id="sidebar" *ngIf="isPlacement==false">
  <div class="sidebar-inner slimscroll">
      <div id="sidebar-menu" class="sidebar-menu">
          <ul *ngIf="menusRes.length == 0">
              <li class="submenu">
                <a  [routerLink]="['/dashboard']" ><i class="fa fa-home"></i> <span> {{'Home' | translate}}</span></a>
              </li>
             <li  class="submenu" *ngFor="let route of (quickLinksMenu$ | async)" >
                  <!-- <a  [routerLink]="['/'+route.link]" href="javascript:void(0);" ><i class="fa fa-dot-circle-o"></i> <span> {{route.smnu_desc}}</span> </a> -->
                  <a  href="javascript:void(0);" (click)="goto(route)"><i class="fa fa-dot-circle-o"></i> <span> {{route.smnu_desc}}</span> </a>
              </li>
          </ul>
          <ul *ngIf="menusRes.length > 0">
              <li class="submenu">
                <a  [routerLink]="['/dashboard']" ><i class="fa fa-home"></i> <span> {{'Home' | translate}}</span></a>
              </li>

              <li class="submenu" *ngFor="let route of menusRes" >
                  <a  href="javascript:void(0);" ><i [class]="route.icon"></i> <span> {{route.mnu_desc}}</span> <span class="menu-arrow"></span></a>
                  <ul style="display: none;">
                      <li *ngFor="let subList of route.sub_menus" ><a [routerLink]="['/'+appRoute+'/'+subList.link]">{{subList.smnu_desc}}</a></li>
                    </ul>
              </li>
              </ul>
              <ul>

              <!-- <li class="submenu"  >
                <a  href="javascript:void(0);" ><i class="fa fa  "></i> <span> Dashboards </span> <span class="menu-arrow"></span></a>
                <ul style="display: none;">

                    <li ><a [routerLink]="['/dashboard/vaccination-dashboard']">vaccination-dashboard</a></li>
                    <li ><a [routerLink]="['/dashboard/workplace-permision-dashboard']">workplace-permision-dashboard</a></li>
                    <li ><a [routerLink]="['/dashboard/Center-SPOC-Dashboard']">Center-SPOC-Dashboard</a></li>
                    <li ><a [routerLink]="['/dashboard/fnf-dashboard']">fnf-dashboard</a></li>
                    <li ><a [routerLink]="['/dashboard/ijp-sga-dashboard']">ijp-sga-dashboard</a></li>
                    <li ><a [routerLink]="['/dashboard/payroll-management-dashboard']">payroll-management-dashboard</a></li>
                    <li ><a [routerLink]="['/dashboard/india-ta-dashboard']">india-ta-dashboard</a></li>
                    <li ><a [routerLink]="['/dashboard/wpd-ivr-dashboard']">wpd-ivr-dashboard</a></li>
                    <li ><a [routerLink]="['/dashboard/rbc-completion-dashboard']">rbc-completion-dashboard</a></li>
                </ul>
            </li> -->

            </ul>
        </div>
    </div>
</div>

<app-employee-id-card [data]="empIDInfo" (childEvent)="childOutput($event)" *ngIf="hasData"></app-employee-id-card>

<app-portal-link></app-portal-link>
<!-- /Sidebar -->
